import React from 'react';

import { Skeleton } from '@atlaskit/avatar';

const AvatarSkeletonHexagonExample = (): React.JSX.Element => {
	return <Skeleton appearance="hexagon" />;
};

export default AvatarSkeletonHexagonExample;
